<template>
  <div>
    <v-card-item
      v-for="gatePass in filteredGatePasses"
      :key="gatePass.gatePassID"
    >
      <template slot="title">
        {{ gatePass.year ? gatePass.year + ' Season Gate Pass' : 'Standard Gate Pass' }}
      </template>
      <template slot="actions">
        <IconButton
          icon="fa-times-circle"
          tooltip="Delete Reservation"
          color="red"
          @click="deleteCartGatePass({gatePassID: gatePass.gatePassID})"
        />
      </template>
      <template>
        <v-layout row>
          <v-flex xs8>
            <strong>ID:</strong> {{ gatePass.gatePassID }}
          </v-flex>
          <v-flex>
            <strong>Price:</strong> ${{ gatePass.price }}
          </v-flex>
        </v-layout>
      </template>
    </v-card-item>
  </div>
</template>

<script>
// user/vehicles?

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GatePasses',
  props: {
    itineraryGroup: {
      type: String,
      default: null
    },
    parkingBooking: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      gatePasses: 'cart/gatePasses'
    }),
    filteredGatePasses () {
      if (this.itineraryGroup) {
        return this.gatePasses.filter((gatePass) => gatePass.itineraryGroup === this.itineraryGroup)
      } else if (this.parkingBooking) {
        return this.gatePasses.filter((gatePass) => gatePass.parkingBookingID === this.parkingBooking)
      }
      return this.gatePasses.filter((gatePass) => !gatePass.itineraryGroup && !gatePass.parkingBookingID)
    }
  },
  methods: {
    ...mapActions({
      deleteCartGatePass: 'cart/deleteCartGatePass'
    })
  }
}
</script>
